import React, { useEffect, useMemo } from 'react';
import axios from 'axios';
import { IQ_API_BASE_URL } from '../../../../config/apiConfig';
import "./Documents.css";
import { useLocation, useParams } from 'react-router-dom';
import { getUrlDetailsObj, getUserStatsObject, recordActivity, getTabType } from "../../../../services/commonService";
import { useDispatch, useSelector } from 'react-redux';
import { fetchDocumentRequest } from '../../../../store/features/actions/documentActions';
import GenericTableSkeleton from '../../skeletons/tableSkeleton/genericTableSkeleton';
import GenericDocumentTableComp from './genericDocumentTableComp';



function parseFlexibleDate(dateStr) {
  // Try common date formats (add more if needed)
  const formats = [
      'DD-MM-YYYY',  // 17-12-2024
      'MM-DD-YYYY',  // 12-17-2024
      'YYYY-MM-DD',  // 2024-12-17
  ];

  for (const format of formats) {
      const parts = format.split('-');
      const dateParts = dateStr.split(/[-/]/); // Split by '-' or '/'

      if (dateParts.length !== 3) continue;

      let day, month, year;

      // Extract day, month, year based on format
      for (let i = 0; i < 3; i++) {
          if (parts[i] === 'DD') day = parseInt(dateParts[i], 10);
          else if (parts[i] === 'MM') month = parseInt(dateParts[i], 10) - 1; // JS months are 0-indexed
          else if (parts[i] === 'YYYY') year = parseInt(dateParts[i], 10);
      }

      if (day && month !== undefined && year) {
          const date = new Date(year, month, day);
          if (!isNaN(date.getTime())) return date;
      }
  }

  // Fallback: Try default Date parsing (less reliable)
  return new Date(dateStr);
}

const DocumentsV2 = () => {
  const { account_info} = useSelector(state=>state?.accountsReducer)
  const accountTicker = account_info?.ticker || '';
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(state => state.documentReducer);
  const { accountId, accountName } = useParams();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = { tab: 'documents' };
  const tab_name = getTabType('documents') || "";


  const documents = useMemo(() => ({
    alldocs : data.sort((a, b) => {
      const dateA = parseFlexibleDate(a.date);
      const dateB = parseFlexibleDate(b.date);
      return dateB - dateA; // Newest first
  }),
  }), [data]);

  useEffect(() => {
    if (accountTicker) {
      dispatch(fetchDocumentRequest(accountTicker));
    }
  }, [accountTicker]);

  const openPdfInNewTab = (url = "") => {
    const userStat = getUserStatsObject(
      tab_name,
      "document_view",
      "Page Source: " + accountName,
      window.location.href,
      accountId
    );
    userStat.url_details = pageParsedData;
    recordActivity(userStat);
    window.open(url, '_blank');
  };

  const downloadFile = async (id, type = "pdf", title = "") => {
    try {
      const docType = type === "xlsx" ? "application/vnd.ms-excel" : "application/pdf";
      const response = await axios.get(`${IQ_API_BASE_URL}/account/documents/${id}`, { responseType: "blob" });
      const newBlob = new Blob([response.data], { type: docType });
      const url = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${accountName} ${title} document`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      const userStat = getUserStatsObject(
        tab_name,
        "document_download",
        "Page Source: " + accountName,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  };

  const formatDate = (dateInput = '01-01-1992') => {
    const [day, month, year] = dateInput.split('-');
    const formatted = new Date(year, month - 1, day);
    return formatted.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  if (error) return <div>Error loading documents</div>;

  if (documents?.alldocs?.length >0) {
    return <>
    <div className="container-fluid">
      {!loading ? (
        <GenericDocumentTableComp
          documents={documents.alldocs}
          openPdfInNewTab={openPdfInNewTab}
          downloadFile={downloadFile}
          formatDate={formatDate}
          baseUrl={IQ_API_BASE_URL}
          title={"All Documents"}
        />
      ) : (
        <GenericTableSkeleton rowCount={15} colCount={4} />
      )}
       </div>
      </>
  }
};

export default React.memo(DocumentsV2);
